import type { VerifyEmailSubmitDataModel, VerifyEmailRequestDto } from './model';

export function modelToDto(submitData: VerifyEmailSubmitDataModel): VerifyEmailRequestDto {
  return {
    action: submitData.action,
    action_metadata: {
      name: submitData.verifyEmailMetadata.name,
      uuid: submitData.verifyEmailMetadata.uuid,
      campaign: submitData.verifyEmailMetadata.campaign,
      survey_template_id: submitData.verifyEmailMetadata.surveyTemplateId,
      verifyWithCode: submitData.verifyEmailMetadata.verifyWithCode,
    },
    email: submitData.email,
    locale: submitData.locale,
  };
}
